import React from "react";
import { IoChatbubbleEllipsesOutline, IoDocumentTextOutline } from "react-icons/io5";
import { RxImage } from "react-icons/rx";
import { EventTabContainer } from "../../styled/scheduler";
import { useSelector } from "react-redux";

const TabMenu = ({ setActive, comments, images, clickGallery, isProject = false }) => {
  const { isDarkMode } = useSelector((state) => state.scheduler);
  const eventMenu = [
    { icon: IoDocumentTextOutline, label: "리포트", key: "report" },
    { icon: RxImage, label: "갤러리", key: "gallery", count: images.length },
    { icon: IoChatbubbleEllipsesOutline, label: "댓글", key: "comment", count: comments.length },
  ];

  return (
    <EventTabContainer className={isProject ? "" : isDarkMode}>
      {eventMenu.map((menu, index) => (
        <li
          onClick={() => (menu.key === "gallery" ? clickGallery(true) : setActive(index + 1))}
          className={menu.key}>
          <menu.icon />
          <span>{menu.label}</span>
          {!!menu?.count && menu?.count > 0 && (
            <div className="dot">{menu?.count > 99 ? "99+" : menu?.count}</div>
          )}
        </li>
      ))}
    </EventTabContainer>
  );
};

export default TabMenu;
